import type { ConfigType } from 'dayjs';
import { useCallback } from 'react';
import { useDayJs } from 'tradera/hooks/use-day-js';
import {
    type FormatOptions,
    formatUtcDateAsSwedishTimeZoneDate
} from 'tradera/utils/date';

export const useFormatUtcDateInSwedishTimeZone = () => {
    const dayjs = useDayJs();

    const formatUtcDateInSwedishTimeZone = useCallback(
        (transactionDate: ConfigType, options?: FormatOptions) =>
            formatUtcDateAsSwedishTimeZoneDate(transactionDate, dayjs, options),
        [dayjs]
    );

    return formatUtcDateInSwedishTimeZone;
};
